import moment from 'moment';

export default {
  format(type = 'YYYY-MM-DD HH:mm:ss', time) {
    return moment(time).format(type);
  },
  valueOf(time) {
    return moment(time).valueOf();
  },
  // 根据传入时间获取当前时间本周的日期
  getWeekListByTime(time) {
    const startTime = moment(time).startOf('week'); // 开始
    const weekList = [];
    for (let i = 0; i < 7; i++) {
      const tempTime = moment(startTime).weekday(i);
      const date = moment(tempTime).format('YYYY-MM-DD');
      weekList.push(date);
    }
    return weekList;
  },
  // 今天
  isToday(time) {
    return this.getLastDay(0) === moment(time).format('YYYY-MM-DD');
  },
  // 昨天
  isYesterday(time) {
    return this.getLastDay(1) === moment(time).format('YYYY-MM-DD');
  },
  // 明天
  isTomorrow(time) {
    return this.getNextDay(1) === moment(time).format('YYYY-MM-DD');
  },
  // 获取上一天
  getLastDay(i, time) {
    return moment(time).subtract(i, 'day').format('YYYY-MM-DD');
  },
  // 获取下一天
  getNextDay(i, time) {
    return moment(time).add(i, 'day').format('YYYY-MM-DD');
  },

  // 本周
  isThisWeek(startTime, endTime) {
    if (!startTime || !endTime) return false;
    const [startDate, endDate] = this.getLastWeek(0);
    const start = startDate === moment(startTime).format('YYYY-MM-DD');
    const end = endDate === moment(endTime).format('YYYY-MM-DD');
    return start && end;
  },
  // 上周
  isLastWeek(startTime, endTime) {
    if (!startTime || !endTime) return false;
    const [startDate, endDate] = this.getLastWeek(1);
    const start = startDate === moment(startTime).format('YYYY-MM-DD');
    const end = endDate === moment(endTime).format('YYYY-MM-DD');
    return start && end;
  },
  // 下周
  isNextWeek(startTime, endTime) {
    if (!startTime || !endTime) return false;
    const [startDate, endDate] = this.getNextWeek(1);
    const start = startDate === moment(startTime).format('YYYY-MM-DD');
    const end = endDate === moment(endTime).format('YYYY-MM-DD');
    return start && end;
  },
  // 获取指定的上周时间，0为当周
  getLastWeek(i, time) {
    const week = moment(time).week() - i * 1;
    const startDate = moment(time)
      .week(week)
      .startOf('week')
      .format('YYYY-MM-DD'); // 周一
    const endDate = moment(time).week(week).endOf('week').format('YYYY-MM-DD'); // 周日
    return [startDate, endDate];
  },
  // 获取指定的下周时间，0为当周
  getNextWeek(i, time) {
    const week = moment(time).week() + i * 1;
    const startDate = moment(time)
      .week(week)
      .startOf('week')
      .format('YYYY-MM-DD'); // 周一
    const endDate = moment(time).week(week).endOf('week').format('YYYY-MM-DD'); // 周日
    return [startDate, endDate];
  },

  // 获取上月
  getLastMonth(i, time) {
    const month = moment(time).month() - i * 1;
    const startDate = moment(time)
      .month(month)
      .startOf('month')
      .format('YYYY-MM-DD'); // 周一
    const endDate = moment(time)
      .month(month)
      .endOf('month')
      .format('YYYY-MM-DD'); // 周日
    return [startDate, endDate];
  },

  // 获取下月
  getNextMonth(i, time) {
    const month = moment(time).month() + i * 1;
    const startDate = moment(time)
      .month(month)
      .startOf('month')
      .format('YYYY-MM-DD'); // 周一
    const endDate = moment(time)
      .month(month)
      .endOf('month')
      .format('YYYY-MM-DD'); // 周日
    return [startDate, endDate];
  },
};
